var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_5923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97875 17.375L9 16.8125L11.25 12.875H14.625C14.9234 12.875 15.2095 12.7565 15.4205 12.5455C15.6315 12.3345 15.75 12.0484 15.75 11.75V5C15.75 4.70163 15.6315 4.41548 15.4205 4.2045C15.2095 3.99353 14.9234 3.875 14.625 3.875H3.375C3.07663 3.875 2.79048 3.99353 2.5795 4.2045C2.36853 4.41548 2.25 4.70163 2.25 5V11.75C2.25 12.0484 2.36853 12.3345 2.5795 12.5455C2.79048 12.7565 3.07663 12.875 3.375 12.875H8.4375V14H3.375C2.77826 14 2.20597 13.7629 1.78401 13.341C1.36205 12.919 1.125 12.3467 1.125 11.75V5C1.125 4.40326 1.36205 3.83097 1.78401 3.40901C2.20597 2.98705 2.77826 2.75 3.375 2.75H14.625C15.2217 2.75 15.794 2.98705 16.216 3.40901C16.6379 3.83097 16.875 4.40326 16.875 5V11.75C16.875 12.3467 16.6379 12.919 16.216 13.341C15.794 13.7629 15.2217 14 14.625 14H11.9025L9.97875 17.375Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.125H4.5V7.25H13.5V6.125Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 9.5H4.5V10.625H10.125V9.5Z",
    fill: "#DCE0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_5923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectUpdates);
export default __webpack_public_path__ + "static/media/project_updates.8e520173364df449a7655a7173835f2a.svg";
export { ForwardRef as ReactComponent };